import { NodeType } from "@/components/devtools/point-cloud-wireframe";
import { create } from "zustand";

export type LodVisualizationSettings = {
  /** Whether to show the LOD visualization. */
  isEnabled: boolean;
  /** The types of LOD nodes to show. */
  nodeType: NodeType;
};

const defaultLodVisualizationSettings: LodVisualizationSettings = Object.freeze(
  {
    isEnabled: false,
    nodeType: NodeType.rendered,
  },
);

export type LodVisualizationSettingsStore = LodVisualizationSettings & {
  setIsEnabled(value: boolean): void;
  setNodeType(value: NodeType): void;
};

/** Context containing settings for the LOD visualization of point clouds. */
export const useLodVisualizationSettings =
  create<LodVisualizationSettingsStore>((set) => ({
    ...defaultLodVisualizationSettings,
    setIsEnabled: (value) => set({ isEnabled: value }),
    setNodeType: (value) => set({ nodeType: value }),
  }));
